import script from "./BidViewActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./BidViewActions.vue?vue&type=script&setup=true&lang=ts"

import "./BidViewActions.vue?vue&type=style&index=0&id=a5602430&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5602430"]])

export default __exports__